
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/variety-packs",
      function () {
        return require("private-next-pages/collections/variety-packs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/variety-packs"])
      });
    }
  